import { i18n } from '@shared';

export function getTranslation(
	translations: SurveyElement['translations'] | undefined,
	target: string,
	lang: string,
	returnNoTranslationText = true,
) {
	const translation =
		translations?.find(
			t => t.translationTarget === target && t.language === lang,
		)?.translationValue || '';

	if (!returnNoTranslationText) {
		return translation;
	}

	if (translation === '') {
		return i18n.t('general.no_translation');
	}

	return translation;
}
